/* Clara Ribera - carrito lateral desplegable.
   Cualquier enlace a /cart abre el cajon (#cart-drawer) y window.crCart.add() anade y lo abre ya actualizado. */
import { CartLinesUpdateEvent } from '@shopify/events';

const crRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const getDrawer = () => document.getElementById('cart-drawer');
const hasDrawer = () => {
  const d = getDrawer();
  return Boolean(d && d.tagName === 'THEME-DRAWER');
};

async function open() {
  if (!hasDrawer()) {
    window.location.href = `${crRoot()}cart`;
    return;
  }
  await customElements.whenDefined('theme-drawer');
  const drawer = getDrawer();
  if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
}

async function add(items) {
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity || 1 })),
      promise: deferred.promise,
    })
  );
  try {
    const response = await fetch(`${crRoot()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sectionIds.join(',') }),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'No se ha podido añadir. Inténtalo de nuevo.');
    }
    const cart = await fetch(`${crRoot()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'cr-product', sourceId: 'cr-product', itemCount: items.length, sections: data.sections, didError: false },
    });
    await open();
    return cart;
  } catch (error) {
    deferred.reject(error);
    throw error;
  }
}

window.crCart = { open, add };

document.addEventListener(
  'click',
  (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : null;
    const link = target ? target.closest('a[href]') : null;
    if (!link || !hasDrawer()) return;
    let url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch (e) {
      return;
    }
    const cartPath = `${crRoot()}cart`;
    if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== cartPath) return;
    event.preventDefault();
    open();
  },
  true
);